// Utilities to clone props with type safety in mind

export const clonePropTypes = component => Object.assign({}, component.propTypes);
export const cloneDefaultProps = component => Object.assign({}, component.defaultProps);

// TODO remove this after deprecating UIComponents part
export const isLegacyComponent = (componentProps, propsList) => propsList.some(prop => {
  var _componentProps$prop;
  return Object.keys((_componentProps$prop = componentProps[prop]) !== null && _componentProps$prop !== void 0 ? _componentProps$prop : {}).length !== 0;
});